import { 
    VISITS_LIST_SUCCESS,
    VISITS_LIST_ERROR,
    VISITS_DETAILS_SUCCESS,
    VISITS_DETAILS_ERROR,
    UPDATE_VISIT_FILTER_OPTIONS,
} from '../actions';
import _ from 'underscore';
import moment from 'moment';

const initialFilterOptions = {
    fromDate: moment().subtract(1, 'months'),
    toDate: moment(),
    filterByClaimant: null,
    filterByCompany: null
}

const initialState = {
    visits: [],
    visitDetails: null,
    isLoaded: false,
    filterOptions: initialFilterOptions,
    visitFilterOptions: initialFilterOptions,
}; 

export default function(state = initialState, action) { 
    switch(action.type) {
        case UPDATE_VISIT_FILTER_OPTIONS:
            return Object.assign({}, state, {
                filterOptions: action.payload,
                visitFilterOptions: action.payload,
            });
        case VISITS_LIST_SUCCESS:
            return Object.assign({}, state, {
                data: action.payload.data.visits, 
                isLoaded: true
            });
        case VISITS_LIST_ERROR:
            return Object.assign({}, state, {
                data: [], 
                isLoaded: false
            });
        case VISITS_DETAILS_SUCCESS:
            const convertedVisitKeyObj = _.indexBy([action.payload.data.visitDetail], 'visitNo');
            const newVisitObj = Object.assign({}, state.viewed, convertedVisitKeyObj);
            return Object.assign({}, state, {
                viewed: newVisitObj
            });
        default:
            return state;
    }
}